import { AutocompleteValue } from '@mui/material';
import { Controller, FieldPathByValue, FieldValues, UseControllerProps } from 'react-hook-form';
import { Skill } from 'shared/types';

import { SkillAutocomplete } from '../../entitySearch';

interface ConnectedSkillAutocompleteProps<TFieldValues extends FieldValues, Multiple extends boolean = false> extends UseControllerProps<TFieldValues> {
    multiple?: Multiple;
    name: Multiple extends true ? FieldPathByValue<TFieldValues, Skill[]> : FieldPathByValue<TFieldValues, Skill>;
}

export default function ConnectedSkillAutocomplete<TFieldValues extends FieldValues, Multiple extends boolean = false>({
    control,
    name,
    ...rest
}: ConnectedSkillAutocompleteProps<TFieldValues, Multiple>) {
    return (
        <Controller 
            name={ name }
            control={ control }
            render={ ({ field: { ref, value, ...field }, fieldState }) => (
                <SkillAutocomplete<Multiple> 
                    { ...field }
                    error={ Boolean(fieldState.error?.message) }
                    helperText={ fieldState.error?.message }
                    inputRef={ ref }
                    value={ value ?? (rest.multiple ? [] : null) as AutocompleteValue<Skill, Multiple, false, false> }
                    { ...rest }
                />
            ) }
        />
    );
}
